module.exports = __webpack_public_path__ + "img/num-bottom.8af4030c.svg";